import { Box, makeStyles, Typography, Grid } from "@material-ui/core";
import { useSelector } from "react-redux";

import { COLORS } from "../../theme/colors";

const useStyles = makeStyles(() => ({
  root: {
    cursor: "pointer",
    paddingTop: 36,
    width: 40,
    margin: "0 auto",
  },
  unselected: {
    color: COLORS.davisGrey,
  },
  selected: {
    color: COLORS.white,
  },
  line: {
    height: 1,
    width: "100%",
    margin: `5px 0 13px`,
  },
}));

export const ByArea = ({ selected = false, xStyle, textStyle, rootStyle, lineStyle }) => {
  const classes = useStyles();
  const { user } = useSelector((state) => state.auth);

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      direction="column"
      className={classes.root}
      style={rootStyle}
    >
      <Typography
        variant="h5"
        className={`${selected ? classes.selected : classes.unselected}`}
        style={xStyle}
      >
        x
      </Typography>
      <Box
        className={classes.line}
        style={{ ...lineStyle, background: selected ? COLORS.white : COLORS.davisGrey }}
      ></Box>
      <Typography
        variant="h5"
        className={`${selected ? classes.selected : classes.unselected}`}
        style={textStyle}
      >
        {user?.unit_system || "sqft"}
      </Typography>
    </Grid>
  );
};

export default ByArea;

ByArea.defaultProps = {
  xStyle: {},
  textStyle: {},
};
